<template>
    <div class="container p-5" style=" margin-top: 50px; margin-bottom: 80px">
        <div class="d-flex flex-row justify-content-between flex-wrap pb-1">
            <h2 class="text-bg">Editar producto</h2>
            <n-button type="info" size="medium" style="font-size: 20px" @click="$router.back()">
                <i class="icon-arrow-left" style="padding-right: 12px;"></i>
                REGRESAR
            </n-button>
        </div>
        <n-form size="large" label-placement="top" :rules="rules" :model="model" ref="formRef">
            <div class="mt-5 mb-3">
                <n-form-item label="Nombre" path="name">
                    <n-input type="text" id="inputName" v-model:value="model.name" placeholder="Ingrese un nombre de producto" />
                </n-form-item>
            </div>

            <div class="mb-3">
                <n-form-item label="Precio" path="price">
                    <n-input id="inputPrice" :show-button='false' v-model:value="model.price"
                        placeholder="Ingrese un precio de producto" min="0" class="w-100" />
                </n-form-item>
            </div>

            <div class="mb-3">
                <n-form-item label="Tipo" path="type">
                    <n-input type="text" id="inputType" v-model:value="model.type" placeholder="Ingrese un tipo de producto" />
                </n-form-item>
            </div>

            <div class="d-flex justify-content-center">
                <n-button type="info" class="text-center w-100" @click="editProduct" style="font-size: 20px">
                    <i class="icon-edit" style="padding-right: 12px;" />
                    EDITAR PRODUCTO
                </n-button>
            </div>
        </n-form>
    </div>
</template>

<script>

import { mapActions, mapState } from 'pinia';
import { useMessage } from 'naive-ui';
import productStore from '../../store/product';
import priceStore from '../../store/price';
import authStore from '../../store/auth';

export default {
    data() {
        return {
            message: useMessage(),
            formRef: null,
            model: {
                name: null,
                price: null,
                type: null
            },
            rules: {
                name: {
                    validator: this.validateName,
                    required: true,
                    trigger: "blur",
                },
                price: {
                    validator(rule, value){
                        let number = Number(value)
                        if (number && number <= 0){
                            rule.message = 'El precio debe ser mayor a 0';
                            return false;
                        } else return true;
                    }
                }
            },
            isTheFormValid: true,
            priceId: null
        }
    },
    async created() {
        const product = await this.getProductsById(this.$route.params.id);
        this.model.name = product.name;
        this.model.price = product.price?.price;
        this.priceId = product.price?._id;
        this.model.type = product.type;

        let data = await this.getNames();
        this.productNames = data.filter((product) => product.name !== this.model.name)
        console.log(this.productNames)
    },
    async mounted() {
        if (!this.isLoggedIn) {
            this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
            this.$router.push('/app/login');
        }
    },
    computed: {
        ...mapState(productStore, ['selectedProduct', 'getNames']),
        ...mapState(priceStore, ['selectedPrice']),
        ...mapState(authStore, ['isLoggedIn'])
    },
    methods: {
        ...mapActions(productStore, ['getProductsById', 'updateProduct']),
        ...mapActions(priceStore, ['updatePrice']),
        validateName(rule, value){
            const nameAlreadyExists = (input, names) =>{
                for (let product of names){
                if (product.name?.toLowerCase() == input.toLowerCase()){
                    return true;
                } else return false;
                }
            }
            if (!value){
                rule.message = 'Por favor ingrese un nombre';
                return false;
            } else {
                if(nameAlreadyExists(value, this.productNames)){
                    rule.message = 'Ese nombre ya existe';
                    return false;
                } else return true
            }
        },
        replaceCommaWithDot(string){
            return string.replace(/,/g, '.');
        },
        async editProduct() {
            this.$refs.formRef.validate();
            if (!this.model.name) {
                this.message.error("Por favor ingrese un nombre")
                this.isTheFormValid = false;
            }
            if (this.model.price && Number(this.model.price <= 0)){
                this.message.error('El precio debe ser mayor a 0');
                this.isTheFormValid = false;
            }
            try {
                if (this.isTheFormValid){
                    if (this.model.price){
                        this.model.price = Number(this.replaceCommaWithDot(this.model.price.toString()));
                    }
                    await this.updateProduct(this.selectedProduct._id, {name: this.model.name, price: this.model.price, type: this.model.type}, this.priceId);
                    this.message.success("Producto editado");
                    this.$router.push('/app/products/list');
                }
                this.isTheFormValid = true;
            } catch (err) {
                console.error(err)
                this.message.error("Error al editar producto");
            }
        }
    },
}

</script>

